<template>
    <v-footer
        app
        absolute
        dark
        height="auto"
    >
        <v-card
            class="white--text"
            style="background-color: #212121; width: 100%"
        >
            <v-card-text class="text-xs-center">
                <v-btn
                    v-for="(icon, index) in icons"
                    :key="index"
                    class="mx-3 white--text"
                    icon
                    @click="changeLocation(icon.route)"
                >
                    <v-icon size="24px">{{ icon.icon }}</v-icon>
                </v-btn>

                <a href="https://www.tiktok.com/@paullivolsi" style="text-decoration: none;">
                    <v-btn icon large>
                        <icon-base
                            style="color: #FFFFFF; margin-top: 10px"
                            icon-color="#FFFFFF"
                            viewbox="0 0 42 42"
                        >
                            <icon-tik-tok/>
                        </icon-base>
                    </v-btn>
                </a>


            </v-card-text>

            <!--            <v-card-text class="white&#45;&#45;text pt-0">-->
            <!--                <v-container>-->
            <!--                    <v-layout row wrap class="footer-link-layout">-->
            <!--                        <div class="footer-links">-->
            <!--                            <div class="body-2">More Info</div>-->
            <!--                            &lt;!&ndash;<div class="caption footer-link">About vorsi.io</div>&ndash;&gt;-->
            <!--                            <div class="caption footer-link" @click="changeLocation('/contact-us')">Contact Us</div>-->
            <!--                        </div>-->
            <!--                        <div class="footer-links">-->
            <!--                            <div class="body-2">Legal</div>-->
            <!--                            <a href="https://vorsi-home.s3.amazonaws.com/vorsi-MSA.docx" download="vorsi-MSA.docx"-->
            <!--                               style="text-decoration: none" class="caption footer-link">Terms Of Use</a>-->
            <!--                            <div class="caption footer-link" @click="privacyPolicy = true">Privacy Policy</div>-->
            <!--                        </div>-->
            <!--                    </v-layout>-->
            <!--                </v-container>-->
            <!--            </v-card-text>-->
        </v-card>
    </v-footer>
</template>

<script>
import IconBase from '../components/icons/IconBase.vue'
import IconTikTok from '../components/icons/IconTikTok.vue'

export default {
    data: () => ({
        termsOfService: false,
        privacyPolicy: false,
        icons: [
            // {icon: 'mdi-facebook', route: 'https://www.facebook.com/getVorsi'},
            // {icon: 'mdi-twitter', route: 'https://twitter.com/getVorsi'},
            // {icon: 'mdi-google', route: 'https://www.google.com/search?q=vorsi'},
            {icon: 'mdi-youtube', route: 'https://www.youtube.com/channel/UC6NDUDHKppocHSTITkI0txw'},
            {icon: 'mdi-instagram', route: 'https://www.instagram.com/livolsimusic'},
            {
                icon: 'mdi-music',
                route: 'https://music.apple.com/us/album/livolsi/1639423134?uo=4&app=itunes&at=1001lry3&ct=dashboard'
            },
            {icon: 'mdi-spotify', route: 'https://distrokid.com/hyperfollow/livolsi/livolsi-2'},
        ]
    }),
    components: {
        IconBase,
        IconTikTok,
    },
    methods: {
        changeLocation(route) {
            window.location = route
        },
        togglePrivacyPolicy(value) {
            this.privacyPolicy = value
        },
        getCurrentYear() {
            return new Date().getFullYear()
        }
    }
}
</script>

<style scoped>

</style>
